import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table } from "../dumb/DataTable";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import Tooltip from "../dumb/Tooltip";

const Suggestions = (props) => {
  const suggestions = useSelector(
    (state) => state.task.tasks[props.taskID]?.suggestions
  );

  const [rows, setRows] = useState(props.rows || []);
  //const [dataUpdated, setDataUpdated] = useState(false);

  useEffectWithoutLoad(() => {
    setRows([]);
    if (suggestions) {
      let glossaryRows = [];
      let memoryRows = [];

      if (suggestions.memory)
        memoryRows = suggestions.memory.map((entry) => [
          entry[2],
          entry[0],
          entry[1],
          "",
          entry[3],
          "memory",
          entry[5], // 6: modified username
          entry[6], // 7: modified first name
          entry[7], // 8: modified last name
          entry[8], // 9: modified date
        ]);

      if (suggestions.glossary)
        /*glossaryRows = suggestions.glossary.map((term) => [
          "TB",
          ...term,
          "glossary",
        ]);*/
        glossaryRows = suggestions.glossary.map((term) => [
          "TB", // 0: type label
          term[0], // 1: source
          term[1], // 2: target
          term[2], // 3: note / ""
          term[3], // 4: glossary ID
          "glossary", // 5: type
          term[4], // 6: modified username
          term[5], // 7: modified first name
          term[6], // 8: modified last name
          term[7], // 9: modified date
        ]);

      if (
        suggestions.memory?.length === 0 &&
        suggestions.glossary?.length === 0
      ) {
        setRows([["", "", "", "", "", "nodata"]]);
      } else {
        setRows(memoryRows.concat(glossaryRows));
        //setRows(glossaryRows.concat(memoryRows));
      }
    }
  }, [suggestions]);

  const copy = (text) => {
    var input = document.createElement("textarea");
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  };

  const ToolTip = ({ row, someText }) => (
    <Tooltip text={<pre>{someText}</pre>}>
      <div className="task-editor__target-char-count tooltip-trigger">
        <span>{row}</span>
      </div>
    </Tooltip>
  );

  const titleContent = (
    <React.Fragment>
      <a
        className="button button--glossary"
        href={
          "javascript:window.open('/task/glossaries/" +
          props.taskID +
          "','_blank','height=600,width=800')"
        }
      >
        Glossaries
      </a>
      <a
        className="button button--memory"
        href={
          "javascript:window.open('/task/memories/" +
          props.taskID +
          "','_blank','height=600,width=800')"
        }
      >
        Memories
      </a>
    </React.Fragment>
  );

  const renderRow = (row, renderData) => (
    <React.Fragment>
      {row[5] != "glossary"
        ? ""
        : renderData(
            <span className="suggestions__type suggestions__type--tb">
              {row[0]}
            </span>,
            { key: "type" }
          )}
      {row[5] != "memory"
        ? ""
        : renderData(
            <span
              className={
                "suggestions__type suggestions__type--" +
                (row[0] == 101 ? "context" : row[0] == 100 ? "exact" : "fuzzy")
              }
            >
              {row[0]}
            </span>,
            { key: "type" }
          )}
      {row[5] == "nodata"
        ? renderData(
            <span className="suggestions__type--no-result suggestions__type">
              No results
            </span>,
            { key: "type" }
          )
        : ""}

      {renderData(
        <div
          className="suggestions__source"
          onClick={() =>
            window.open(
              `/task/tmdiff/${props.rowID}`,
              "_blank",
              "height=600,width=800"
            )
          }
        >
          {row[1]}
        </div>,
        { key: "source" }
      )}
      {renderData(
        <div className="suggestions__target" onClick={() => copy(row[2])}>
          <ToolTip
            row={row[2]}
            someText={
              row[7] || row[8] || row[9]
                ? `Modified: ${[row[7], row[8]].filter(Boolean).join(" ")}${
                    row[9] ? " " + row[9] : ""
                  }`
                : "Modified: unknown"
            }
          />
        </div>,
        { key: "target" }
      )}
      {renderData(row[3], { key: "sdfes" })}
      {/* {row[5] != "glossary" ? "" : <Data><Lnk here={"/PM/glossary/view/" + row[4]}>{row[4]}</Lnk></Data>}
            {row[5] != "memory" ? "" : <Data><Lnk here={"/PM/memory/view/" + row[4]}>{row[4]}</Lnk></Data>} */}
    </React.Fragment>
  );

  return (
    <Table
      title="Suggestions"
      titleContent={titleContent}
      cols={[
        { name: "type" },
        { name: "source", class: "table__header--source" },
        { name: "target", class: "table__header--target" },
        { name: "note" },
      ]}
      renderRow={renderRow}
      rows={rows}
    />
  );
};

export default Suggestions;
